module.exports = __webpack_public_path__ + "img/Monte_Kope_94.22f925d7.jpg";